import d from "./node_modules/i18next-http-backend/esm/index.js";export default d;